/**
 * Utilitários para montar HTML como texto (ex.: cupom impresso via document.write)
 *
 * @author Equipe VendeAi
 * @since 1.4.0
 */

const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;',
};

/**
 * Escapa um valor para interpolar em HTML (conteúdo ou atributo entre aspas).
 * null/undefined viram texto vazio. Use em TODO dado vindo do usuário/servidor
 * (nome de produto, observações, nome do cliente, endereço...).
 */
export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[&<>"'`]/g, ch => HTML_ESCAPES[ch] ?? ch);
}

/**
 * URL segura para src de imagem no HTML gerado: só http(s), data:image e caminhos
 * relativos; qualquer outro esquema (javascript:, etc.) vira vazio. Já escapada.
 */
export function safeImageUrl(url: unknown): string {
  if (typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (/^(https?:\/\/|data:image\/|\/(?!\/))/i.test(trimmed)) return escapeHtml(trimmed);
  return '';
}
